import { WebsocketService } from '@galigeo-store/ui-components';
import { RESTUtils } from '@galigeo-store/ui-lib';

export const websocketService = new WebsocketService({
  baseUrl: import.meta.env.VITE_WORKFLOW_API_URL + '/ws',
  token: RESTUtils.getToken(),
});
